import React, { useState } from "react";
import { signIn } from "../../redux/actions/authActions";
import { useDispatch, useSelector } from "react-redux";
import { Link, Redirect } from "react-router-dom";

// TODOs logo visual'dan alınacak.
import { Form, Grid, Header, Image, Segment, Message } from "semantic-ui-react";
const SignIn = () => {
  const uid = useSelector((state) => state.firebase.auth.uid);
  const dispatch = useDispatch();

  const [state, setState] = useState({
    email: "",
    password: "",
  });

  const handleChange = (e) => {
    setState({
      ...state,
      [e.target.id]: e.target.value,
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    console.log(state);
    dispatch(signIn(state));
  };

  if (uid) return <Redirect to="/" />;
  return (
    <Grid
      textAlign="center"
      style={{ height: "79.5vh" }}
      verticalAlign="middle"
    >
      <Grid.Column
        style={{
          maxWidth: 450,
          boxShadow:
            "0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19)",
        }}
      >
        <Header
          as="h2"
          color="blue"
          textAlign="center"
          style={{ paddingTop: "6px" }}
        >
          <Image
            src="https://firebasestorage.googleapis.com/v0/b/omnes-immigration.appspot.com/o/assets%2Fimages%2Ficon-set%2Ficon-america.png?alt=media&token=3a531c4a-5eff-43e5-a019-1d3c519cb18b"
            style={{ marginTop: "-6px", marginRight: "8px" }}
          />{" "}
          <span
            style={{
              color: "royalblue",
            }}
          >
            Log in to your account
          </span>
        </Header>
        <Form size="large" onSubmit={handleSubmit}>
          <Segment stacked>
            <Form.Input
              id="email"
              fluid
              icon="user"
              iconPosition="left"
              placeholder="E-mail address"
              onChange={handleChange}
            />
            <Form.Input
              id="password"
              fluid
              icon="lock"
              iconPosition="left"
              placeholder="Password"
              type="password"
              onChange={handleChange}
            />

            <Form.Button
              style={{ backgroundColor: "royalblue", color: "white" }}
              fluid
              type="submit"
              size="large"
            >
              Log In
            </Form.Button>
            <Link to="reset">Did you forget your password?</Link>
          </Segment>
        </Form>
        <Message compact size="large">
          If you haven't subscribed to Omnes Immigration yet, please make sure
          to <Link to="/signup">Sign Up</Link> fist in order to access payment
          plans.
        </Message>
      </Grid.Column>
    </Grid>
  );
};

export default SignIn;
